import {
  Accordion,
  Button,
  Code,
  Group,
  List,
  Tabs,
  Text,
} from "@mantine/core";
import { IconPrinter } from "@tabler/icons-react";

import { printTicket } from "../../utils/printTicket";

const StationPrintSetup = () => (
  <Accordion variant="separated" w="100%" maw={640}>
    <Accordion.Item value="setup">
      <Accordion.Control icon={<IconPrinter size={18} />}>
        How to enable silent printing
      </Accordion.Control>
      <Accordion.Panel>
        <Text size="sm" c="dimmed" mb="sm">
          Silent printing (no print dialog) needs the browser launched with the
          kiosk flag and a default printer. Without the flag it still works, but
          a print dialog appears each time.
        </Text>
        <Tabs defaultValue="windows">
          <Tabs.List>
            <Tabs.Tab value="windows">Windows</Tabs.Tab>
            <Tabs.Tab value="macos">macOS</Tabs.Tab>
            <Tabs.Tab value="linux">Linux</Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="windows" pt="sm">
            <List type="ordered" size="sm" spacing={6}>
              <List.Item>Quit Chrome completely (close all windows).</List.Item>
              <List.Item>Right-click the desktop → New → Shortcut.</List.Item>
              <List.Item>
                Set the location to:
                <Code block mt={4}>
                  {
                    '"C:\\Program Files\\Google\\Chrome\\Application\\chrome.exe" --kiosk-printing'
                  }
                </Code>
              </List.Item>
              <List.Item>Name it “Check-in Station”.</List.Item>
              <List.Item>
                Set a default printer: Settings → Bluetooth &amp; devices →
                Printers &amp; scanners → pick the printer → Set as default.
              </List.Item>
              <List.Item>Always open the station via this shortcut.</List.Item>
            </List>
            <Text size="xs" c="dimmed" mt="sm">
              Edge works the same way — use{" "}
              <Code>msedge.exe --kiosk-printing</Code>. If Chrome is already
              running without the flag, close all windows first so the new one
              picks it up.
            </Text>
          </Tabs.Panel>

          <Tabs.Panel value="macos" pt="sm">
            <List type="ordered" size="sm" spacing={6}>
              <List.Item>Quit Chrome completely (Cmd + Q).</List.Item>
              <List.Item>
                Open Terminal and run:
                <Code block mt={4}>
                  {'open -a "Google Chrome" --args --kiosk-printing'}
                </Code>
              </List.Item>
              <List.Item>
                Set a default printer: System Settings → Printers &amp; Scanners
                → select the printer → Set as default.
              </List.Item>
            </List>
          </Tabs.Panel>

          <Tabs.Panel value="linux" pt="sm">
            <List type="ordered" size="sm" spacing={6}>
              <List.Item>Quit Chrome completely (close all windows).</List.Item>
              <List.Item>
                Run:
                <Code block mt={4}>
                  google-chrome --kiosk-printing
                </Code>
              </List.Item>
              <List.Item>
                Set the default printer in system settings, or run{" "}
                <Code>lpoptions -d &lt;printer-name&gt;</Code>.
              </List.Item>
            </List>
          </Tabs.Panel>
        </Tabs>
        <Group justify="space-between" align="center" mt="md">
          <Text size="xs" c="dimmed">
            Prints a sample badge to check the printer, paper size, and whether
            printing is silent.
          </Text>
          <Button
            variant="light"
            leftSection={<IconPrinter size={16} />}
            onClick={() =>
              printTicket({ firstName: "Test", lastName: "Print" })
            }
          >
            Test print
          </Button>
        </Group>
      </Accordion.Panel>
    </Accordion.Item>
  </Accordion>
);

export default StationPrintSetup;
